import { useApi } from '~shared/providers/use-api';

import type { QueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { Merchant } from './merchant';

import type { MerchantApi } from '../api/merchant-api';
import { MERCHANT_API_KEY } from '../api/merchant-api';

export function useMerchantsListQuery(
  queryOptions: QueryOptions<Merchant[]> = {}
) {
  const merchantApi = useApi<MerchantApi>(MERCHANT_API_KEY);

  return useQuery({
    queryKey: ['merchants-list'],
    queryFn: () => merchantApi.getMerchants(),
    ...queryOptions,
  });
}
